var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video--container embed-responsive embed-responsive-16by9"},[_c('video',{staticClass:"border-0",attrs:{"allowfullscreen":"","muted":"","controls":"","loop":"","autoplay":"","preload":"none"},domProps:{"muted":true}},[_c('source',{attrs:{"src":`${_vm.MEDIA_URL}video-corporativo-torbel-low.mp4`,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }